<template>
    <v-card @click="onClickPlace()" class="pa-2">
        <div class="d-flex flex-no-wrap justify-space-left">
            <div>
                <v-avatar v-if="place.body.image != null" rounded>
                    <v-img :src="place.body.image.url" width="64" />
                </v-avatar>
            </div>
            <div style="width:100%" class="ml-1">
                <table style="width:100%">
                    <tr>
                        <td v-if="place.body.managementAgrichemical.enabled">
                            <v-icon >mdi-pill</v-icon>
                        </td>
                        <td style="width:100%; white-space:normal">                                                                    
                            {{place.body.name}}
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-if="!isShareMode"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        color="primary"
                                        icon>
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item 
                                        v-for="menuItem in menuItems" :key="menuItem.type"
                                        @click="onSelectedMenu(menuItem)">
                                        <v-list-item-icon><v-icon>{{menuItem.icon}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{menuItem.text}}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                    <tr v-if="place.body.address != null && place.body.address.pref != '' && place.body.address.city != ''">
                        <td style="font-size:xx-small" colspan="2">
                            <v-divider class="mb-1" />
                            {{place.body.address.pref}}{{place.body.address.city}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </v-card>    
</template>

<script>
    export default {
        props: {
            place: null,
            isShareMode: false
        },
        data: function () {
            return {
                /**
                 * メニュー
                 */
                menuItems: [
                    {icon: "mdi-pencil-outline", type: "edit", text: "編集"},
                    {icon: "mdi-delete", type: "delete", text: "削除"},
                ],
            }
        },
        methods: {
            onClickPlace: function () {
                this.$emit("onClickPlace", this.place)
            },
            onSelectedMenu: function (menuItem) {
                this.$emit("onSelectedMenu", this.place, menuItem.type)
            }
        }
    }
</script>